<template>
  <div class="animated fadeIn">

    <b-card-body class="m-0 pt-0" id="areaImprimir" >
      <div class="text-center">
            <b-spinner v-if="!process" label="Spinning"></b-spinner>
          </div>

          <div v-if="process.length > 0">

        <b-row class="border-bottom mb-2">
          <b-col>
            <b-img  :src="img" left fluid style="max-height: 100px" alt="Responsive image"  class="rounded pb-0"></b-img>
            <h1 class="text-right">INFORME DE PROCESO LOTE #{{numLotSearch}}</h1>
            <!-- <p class="text-right">{{process[0].process_date | moment }}</p> -->
            <a href="#" class="float-right text-black-50" @click="descargarPDF"><i class="fa fa-download"></i></a>
          </b-col>
        </b-row>
         <b-row class="mb-4">
          <b-col sm="6">
            <h6 class="mb-3">Procesado en:</h6>
             <div><strong>{{process[0].plant.name}}</strong></div>
            <div>CSP: {{process[0].plant.plant_code}}</div>
            <div>{{process[0].plant.company.address1}}</div>
            <div>Email: {{process[0].plant.company.email}}</div>
            <div>Telefono: {{process[0].plant.company.phone}}</div>
          </b-col>

 
          <b-col sm="6" >
            <span class="text-right">
            <h6 class="mb-3" >Solicitud:</h6>
            <div><strong>{{ process[0].client_customer.company_name }}</strong></div>
            <div>Huerto: {{process[0].contents_in[0].origin_name === undefined ? "": process[0].contents_in[0].origin_name}} ({{process[0].contents_in[0].origin_code === undefined ? "": process[0].contents_in[0].origin_code}})</div>
            <div>Guia: {{process[0].contents_in[0].waybill_number}}</div>
            <div>Producto: {{process[0].contents_in[0].product_name}}</div>
            <div>Variedad: {{process[0].contents_in[0].variety_name}}</div>
            <div>Condicion: {{process[0].contents_in[0].condition}}</div>
             <div>Fecha:  {{process[0].contents_in[0].waybill_date | moment}} </div>
             </span>
          </b-col>
<!--           <b-col sm="3">
            <h6 class="mb-3">Detalles:</h6>
            <div class="font-weight-bold">Kilos Volteados: {{this.calTotal.kilos_Volteados.toFixed(2)}} KG</div>
            <div class="font-weight-bold">Unidades: {{this.calTotal.unidades.toFixed(2)}} UN </div>
            <div class="font-weight-bold">Kilos Exportación: {{this.calTotal.kilos_Exportacion.toFixed(2)}} KG</div>
            <div class="font-weight-bold">Deshidratación/SobrePeso: {{this.calTotal.deshidratación_SobrePeso.toFixed(2)}} KG</div>
          </b-col> -->
<!--            <b-col sm="3">
            <h6 class="mb-3">Porcentajes:</h6>
            <div v-for="process_type in typeProductObj">
              <div class="font-weight-bold">{{process_type.producto}}: {{process_type.porcentaje.toFixed(2)}} %</div>
            </div>
          </b-col> -->
        </b-row>
        <hr>
        <template>
        <h6 class="mb-2 font-weight-bold"></h6>
        <div class="table-responsive-sm">
          <table class="table  table-sm">
            <thead>
              <tr class="font-weight-bold text-uppercase">
                <th class="text-center align-middle" >Kilos<br> Volteados<br>(KG)</th>
                <th>Embalaje<br>Calibre</th>
                <th class="text-center">Unidades<br>(UN)</th>
                <th class="text-right">Exportacion<br>(KG)</th>
                <th class="text-right">SobrePeso<br>(KG)</th>
                <th class="text-center">Descarte<br>(KG)</th>
                <th class="text-center">Merma<br>(KG)</th>
                <th class="text-center">kg Calidad<br>(KG)</th> 
                <th class="text-center" v-for="process_type in typeProductObj">{{process_type.producto}}<br>(%)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(content, index) in processConsolidated">

                <td class="text-center align-middle" v-show="index==0" :rowspan="totalProcessConsolidated" >{{calTotal.kilos_Volteados}}</td>
                <td class="left align-middle">{{content.container__name}} - {{content.string_specs}} </td>
               <!--  <td class="text-center" v-if="content.container__name=='Malla 25 Kg'">{{parseFloat(content.totalQuantity / 25).toFixed(2)}}</td>
                <td class="text-center" v-if="content.container__name=='Malla incompleta en kilos'">{{parseFloat(content.totalQuantity * 0.04).toFixed(2)}}</td> mallas incompletas -->
                <td class="text-center">{{parseFloat(content.KgExportacion / 25).toFixed(2)}}</td>
                <td class="text-right">{{content.KgExportacion}}</td>
                <td class="text-right">{{content.DhSobrePeso}}</td>
                <td class="text-center align-middle" v-show="index==0" :rowspan="totalProcessConsolidated" >{{calTotal.descarte }}</td>
                <td class="text-center align-middle" v-show="index==0" :rowspan="totalProcessConsolidated" >{{calTotal.merma}}</td>
                <td class="text-center align-middle" v-show="index==0" :rowspan="totalProcessConsolidated" >{{calTotal.kg_calidad}}</td>
                <td class="text-center align-middle" v-show="index==0" :rowspan="totalProcessConsolidated" v-for="process_type in typeProductObj" >{{process_type.porcentaje.toFixed(2)}} %</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="font-weight-bold">
                <td left>TOTALES</td>
                <td class="text-right"></td>
                <td class="text-center">{{this.calTotal.unidades.toFixed(2)}} UN</td>
                <td class="text-right"> {{this.calTotal.kilos_Exportacion.toFixed(2)}} KG</td>
                <td class="text-right"> {{this.calTotal.deshidratación_SobrePeso.toFixed(2)}} KG </td>
                <td class="text-right"></td>
                <td class="text-right"></td>
                <td class="text-right"></td>
                <td class="text-right"></td>
              </tr>
            </tfoot>
          </table>
        </div>

      <b-row>
     <!--  <b-col lg="6">
        <b-card border-variant="white">
          <p>Notas: {{process.note}}</p>
        </b-card>
      </b-col> -->

    </b-row>
      </template>
          </div>

        <hr>
      <p class="small text-center">El Porcentaje de embalaje corresponde
        a la suma de los kilos netos de exportación, más los
        kilos netos de deshidratación, y se considera como el rendimiento efectivo de la fruta.
      </p>

      </b-card-body> 

  </div>
</template>

<script>

  import html2pdf from 'html2pdf.js'
  import moment from 'moment';
  import _ from 'lodash'

    export default {
      name: "ReportProcessLot",
      props: ['process','numLotSearch','processConsolidated'],
      data () {
        return {
          img:'',
          client: null,
          totalProcessConsolidated:0,
          calTotal:{
            kilos_Volteados:0,
            unidades:0,
            kilos_Exportacion:0,
            deshidratación_SobrePeso:0,
            merma:0,
            descarte:0,
            kg_calidad:0,
          },
          objProduct:[],
          typeProductObj:[],
        }
      },
      filters: {
        moment: function (date) {
          return moment(date).format('DD-MM-YYYY');
        }
      },
      computed: {
      },
      methods: {
        totalQuantity(obj){
            var totalQuantity=0;
            for(let i in obj)
            {
                if(obj[i].waste==false)
                {
                    totalQuantity=parseFloat(totalQuantity) + (parseFloat(obj[i].exportable_kilograms) / 25);
                }
            }
           return totalQuantity;
        },
        totalNetKilograms(obj) {
         const value = obj.reduce((total, item) => total + parseFloat(item.net_kilograms), 0);
         return value.toFixed(2);
        },
        totalExportedKilogram(obj) {
          var value = obj.reduce((acc, item) => acc + parseFloat(item.exportable_kilograms), 0);
          return value.toFixed(2);
        },
        totalDHKilogram(obj) {
          const value = obj.reduce((acc, item) => acc + parseFloat(this.dh(item.exportable_kilograms, item.net_kilograms)),0);
          return value.toFixed(2);
        },
        dh(exportable_kilogram, net_kilogram) {
          const value = (net_kilogram - exportable_kilogram);
          return exportable_kilogram == 0 ? 0 : parseFloat(value).toFixed(2)
        },
        groupedData (process) {
            return _(process.contents_out)
                  .groupBy('product_type_name')
                  .map((product_type, id) => (
                    {
                    producto: id,
                    kg_export: _.sumBy(product_type,'exportable_kilograms'),
                    kg_sobrepeso: _.sumBy(product_type, x => parseFloat(x.net_kilograms - x.exportable_kilograms)).toFixed(2),
                    bultos: _.sumBy(product_type, 'quantity'),
                    porcentaje: (
                      _.sumBy(product_type, x => parseFloat(x.net_kilograms))/parseFloat(process.total_kilograms)
                    * 100 ).toFixed(2)  +"%",

                  }
                  ))
                  .value()         
        },
        sumPorcentajes() {
         for(let key in this.objProduct[0]){
           var porcentaje=0;
            for(let key2 in this.objProduct){
                for(let key3 in this.objProduct[key2]){
                  if(this.objProduct[key2][key3].producto==this.objProduct[0][key].producto){
                      porcentaje=parseFloat(porcentaje) + parseFloat(this.objProduct[key2][key3].porcentaje);
                  }
                } 
            } 
            this.typeProductObj.push(
                {
                'producto':this.objProduct[0][key].producto,
                'porcentaje':porcentaje/this.objProduct.length
                }
            );
         }
        },
        totalMerma(obj){
            var total=0;
            for(let i in obj){
                if(obj[i].product_type_name=="Merma")
                {
                    total=parseFloat(total) + parseFloat(obj[i].net_kilograms);
                }
            }
           return total;
        },
         totalDescarte(obj){
            var total=0;
            for(let i in obj){
                if(obj[i].product_type_name=="Descarte")
                {
                    total=parseFloat(total) + parseFloat(obj[i].net_kilograms);
                }
            }
           return total;
        },
         totalKgCalidad(obj){
            var total=0;
            for(let i in obj){
                if(obj[i].product_type_name=="Kg Calidad")
                {
                    total=parseFloat(total) + parseFloat(obj[i].net_kilograms);
                }
            }
           return total;
        },
       totalCal(){
        this.calTotal.kilos_Volteados = 0;
        this.calTotal.unidades = 0;
        this.calTotal.kilos_Exportacion = 0;
        this.calTotal.deshidratación_SobrePeso = 0;

        this.calTotal.merma = 0;
        this.calTotal.descarte = 0;

        for(let key in this.process ){

          this.calTotal.kilos_Volteados += parseFloat(this.totalNetKilograms(this.process[key].contents_in));
          this.calTotal.unidades += parseFloat(this.totalQuantity(this.process[key].contents_out));
          this.calTotal.kilos_Exportacion += parseFloat(this.totalExportedKilogram(this.process[key].contents_out));
          this.calTotal.deshidratación_SobrePeso += parseFloat(this.totalDHKilogram(this.process[key].contents_out));

          this.calTotal.merma += parseFloat(this.totalMerma(this.process[key].contents_out));
          this.calTotal.descarte += parseFloat(this.totalDescarte(this.process[key].contents_out));
          this.calTotal.kg_calidad += parseFloat(this.totalKgCalidad(this.process[key].contents_out));

          let dato= this.groupedData(this.process[key]);
          this.objProduct.push(Object.assign({}, dato)); 

         }

        this.sumPorcentajes(); 
       },
        moment: function () {
          return moment();
        },
        printDiv() {
          const prtHtml = document.getElementById('areaImprimir').innerHTML;
          let stylesHtml = '';
          for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
            stylesHtml += node.outerHTML;
          }
          const WinPrint = window.open('', '', 'left=0,top=5,width=1280,height=2900,toolbar=0,scrollbars=0,status=0');
          WinPrint.document.write(`<!DOCTYPE html>
          <html>
            <head>
              ${stylesHtml}
            </head>
            <body>
              ${prtHtml}
            </body>
          </html>`);

          WinPrint.document.close();
          WinPrint.focus();
          WinPrint.print();
          WinPrint.close();

        },
        descargarPDF() {
          const element = document.getElementById('areaImprimir').innerHTML;
          const opt = {
            margin: 0.25,
            image: { type: 'jpeg', quality: 1},
            filename: 'Informe Proceso Lote#'+this.numLotSearch+'.pdf',
            html2canvas: { scale: 2, letterRendering: true },
            jsPDF: {unit: 'in', format: 'letter', orientation: 'landscape'}
          };
          html2pdf(element, opt);
        }
      },
       mounted() {
        this.img = localStorage.getItem('img');
        this.client = this.$store.getters.user.ID_CLIENTE;
        setTimeout(()=> {
            
            this.totalCal();
            this.totalProcessConsolidated=this.processConsolidated.length;
        
        },2000);
      },
      

    };


</script>

<style scoped>
  .table-sm th, .table-sm td {
    padding: 0.15rem;
}
</style>
